import {EventPositions, IEventCompetitor} from "./types";
import {DateTime} from 'luxon';

export const unknownEventScoreString = '--:--';

export const findEventCompetitorByPosition = (eventCompetitors: IEventCompetitor[], position: EventPositions): IEventCompetitor|null => eventCompetitors.find((eventCompetitor: IEventCompetitor) => eventCompetitor.position === position) ?? null;

export const findCompetitorTrNameByPosition = (eventCompetitors: IEventCompetitor[], position: EventPositions): string|null => findEventCompetitorByPosition(eventCompetitors, position)?.competitor?.trName ?? null;

export const formatEventTitle = (eventTitle: string, isMobile: boolean): string => {
  const maxNumberChars: number = 18;

  if (isMobile && eventTitle.length > maxNumberChars) {
    return `${eventTitle.substring(0, maxNumberChars - 3)}...`;
  }

  return eventTitle;
}

export const getTranslatedEventName = (eventCompetitors: IEventCompetitor[], separator: string = ' - '): string => {
  if (eventCompetitors.length > 2) {
    const homeFirstTeamTrName = findCompetitorTrNameByPosition(eventCompetitors, EventPositions.home);
    const homeSecondTeamTrName = findCompetitorTrNameByPosition(eventCompetitors, EventPositions.homeSecond);
    const awayFirstTeamTrName = findCompetitorTrNameByPosition(eventCompetitors, EventPositions.away);
    const awaySecondTeamTrName = findCompetitorTrNameByPosition(eventCompetitors, EventPositions.awaySecond);
    return `${homeFirstTeamTrName}/${homeSecondTeamTrName}${separator}${awayFirstTeamTrName}/${awaySecondTeamTrName}`;
  } else {
    const homeTeamTrName = findCompetitorTrNameByPosition(eventCompetitors, EventPositions.home);
    const awayTeamTrName = findCompetitorTrNameByPosition(eventCompetitors, EventPositions.away);
    return `${homeTeamTrName}${separator}${awayTeamTrName}`;
  }
}

export const getPrevEventStatusIndicatorClassName = (meetingResult: string): string => {
  let classColor: string|null = '';

  switch (meetingResult) {
    case 'win':
      classColor = 'stats-item--win';
      break;
    case 'loss':
      classColor = 'stats-item--loss';
      break;
    case 'draw':
      classColor = 'stats-item--draw';
      break;
    default:
      classColor = '';
  }

  return classColor;
}

export const getPrevEventStatusLetter = (meetingResult: string): string => {
  let classColor: string|null = '';

  switch (meetingResult) {
    case 'win':
      classColor = 'W';
      break;
    case 'loss':
      classColor = 'L';
      break;
    case 'draw':
      classColor = 'D';
      break;
    default:
      classColor = '-';
  }

  return classColor;
}

// Function takes date in  string ISO format and returns true if that date is in the next custom number hours;
// Default in 24 hours;
export const isInNextHours = (date: string, hours: number = 24): boolean => {

  const now = DateTime.now();
  const event = DateTime.fromISO(date);

  //get unix time of event and now then subtract
  const timeBetween = event['ts'] - now['ts'];

  const milliseconds = 3600000 * hours;

  return (timeBetween < milliseconds && timeBetween > 0)
}

export const getEventLink = (linkTemplate: string, eventId: number, eventName: string, sportName: string, competitionName: string, regionName: string, regionNameTr: string, sportNameTr: string): string => {
  if (linkTemplate) {
    return linkTemplate
    .replace('{eventID}', eventId.toString())
    .replace('{competitionName}', competitionName)
    .replace('{sportName}', sportName)
    .replace('{regionName}', regionName)
    .replace('{regionNameTranslated}', regionNameTr)
    .replace('{sportNameTranslated}', sportNameTr)
    .replace('{eventName}', eventName);
  }

  console.error(`Widget error: Could not find link template for redirection to match center.`);
  return '';
}

export const contentTypes = {
  oddsAndPreview: '1-odds-and-preview-content',
  bettingTips: '5-betting-tips',
  form: '7-form',
  faq: '12-faq'
}
